/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  Export400Response,
  Export422Response,
  ExportRequest,
  GetClasses200Response,
  GetClasses400Response,
  GetCommonState400Response,
  GetSuggestedWord200Response,
  GetSuggestedWord422Response,
  GetWords200Response,
  GetWords400Response,
  Import200Response,
  Import400Response,
  Import422Response,
  Search200Response,
  Search422Response,
  SearchRequest,
} from '../models/index'
import {
  Export400ResponseFromJSON,
  Export400ResponseToJSON,
  Export422ResponseFromJSON,
  Export422ResponseToJSON,
  ExportRequestFromJSON,
  ExportRequestToJSON,
  GetClasses200ResponseFromJSON,
  GetClasses200ResponseToJSON,
  GetClasses400ResponseFromJSON,
  GetClasses400ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetSuggestedWord200ResponseFromJSON,
  GetSuggestedWord200ResponseToJSON,
  GetSuggestedWord422ResponseFromJSON,
  GetSuggestedWord422ResponseToJSON,
  GetWords200ResponseFromJSON,
  GetWords200ResponseToJSON,
  GetWords400ResponseFromJSON,
  GetWords400ResponseToJSON,
  Import200ResponseFromJSON,
  Import200ResponseToJSON,
  Import400ResponseFromJSON,
  Import400ResponseToJSON,
  Import422ResponseFromJSON,
  Import422ResponseToJSON,
  Search200ResponseFromJSON,
  Search200ResponseToJSON,
  Search422ResponseFromJSON,
  Search422ResponseToJSON,
  SearchRequestFromJSON,
  SearchRequestToJSON,
} from '../models/index'

export interface ExportOperationRequest {
  exportRequest: ExportRequest
}

export interface ImportRequest {
  file: Blob
}

export interface GetSuggestedWordRequest {
  word: string
}

export interface GetWordsRequest {
  classNumber: number
}

export interface SearchOperationRequest {
  searchRequest: SearchRequest
}

/**
 * MktuApi - interface
 *
 * @export
 * @interface MktuApiInterface
 */
export interface MktuApiInterface {
  /**
   * Экспорт выбранных классов МКТУ и их фраз в docx-файл (Word2007). Файл отдаётся как вложение (Content-Disposition: attachment), а не в конверте success_response. Публичный эндпоинт.
   * @summary Экспорт классов МКТУ в docx
   * @param {ExportRequest} exportRequest Список классов с выбранными фразами (до 45 классов)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MktuApiInterface
   */
  _exportRaw(
    requestParameters: ExportOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Экспорт выбранных классов МКТУ и их фраз в docx-файл (Word2007). Файл отдаётся как вложение (Content-Disposition: attachment), а не в конверте success_response. Публичный эндпоинт.
   * Экспорт классов МКТУ в docx
   */
  _export(
    requestParameters: ExportOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>

  /**
   * Конвертация docx-файла со списком фраз классов МКТУ в JSON: содержимое word/document.xml разбирается напрямую (разрывы строк внутри абзаца сохраняются как перевод строки). Публичный эндпоинт.
   * @summary Импорт классов МКТУ из docx
   * @param {Blob} file Файл .docx
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MktuApiInterface
   */
  _importRaw(
    requestParameters: ImportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Import200Response>>

  /**
   * Конвертация docx-файла со списком фраз классов МКТУ в JSON: содержимое word/document.xml разбирается напрямую (разрывы строк внутри абзаца сохраняются как перевод строки). Публичный эндпоинт.
   * Импорт классов МКТУ из docx
   */
  _import(
    requestParameters: ImportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Import200Response>

  /**
   * Список всех 45 классов МКТУ с описаниями, пояснениями и счётчиками фраз (отдаётся из кеша). Публичный эндпоинт.
   * @summary Список классов МКТУ
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MktuApiInterface
   */
  getClassesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetClasses200Response>>

  /**
   * Список всех 45 классов МКТУ с описаниями, пояснениями и счётчиками фраз (отдаётся из кеша). Публичный эндпоинт.
   * Список классов МКТУ
   */
  getClasses(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetClasses200Response>

  /**
   * По одному слову находит полные ключевые фразы классов МКТУ (подсказки при вводе). Запрос очищается от небезопасных символов, обрезается до 255 символов; поиск сохраняется в историю (для аутентифицированных — с привязкой к пользователю). Публичный эндпоинт.
   * @summary Подсказки ключевых фраз МКТУ по слову
   * @param {string} word Искомое слово (минимальная длина задаётся серверной настройкой)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MktuApiInterface
   */
  getSuggestedWordRaw(
    requestParameters: GetSuggestedWordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetSuggestedWord200Response>>

  /**
   * По одному слову находит полные ключевые фразы классов МКТУ (подсказки при вводе). Запрос очищается от небезопасных символов, обрезается до 255 символов; поиск сохраняется в историю (для аутентифицированных — с привязкой к пользователю). Публичный эндпоинт.
   * Подсказки ключевых фраз МКТУ по слову
   */
  getSuggestedWord(
    requestParameters: GetSuggestedWordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetSuggestedWord200Response>

  /**
   * Все ключевые фразы указанного класса МКТУ, отсортированные по алфавиту и базовому номеру. Публичный эндпоинт.
   * @summary Ключевые фразы класса МКТУ
   * @param {number} classNumber Номер класса МКТУ (1–45)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MktuApiInterface
   */
  getWordsRaw(
    requestParameters: GetWordsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetWords200Response>>

  /**
   * Все ключевые фразы указанного класса МКТУ, отсортированные по алфавиту и базовому номеру. Публичный эндпоинт.
   * Ключевые фразы класса МКТУ
   */
  getWords(
    requestParameters: GetWordsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetWords200Response>

  /**
   * Мультисловный поиск по классам МКТУ: для каждого переданного слова — найденные ключевые фразы классов; слова без соответствий собираются в data.undefined. Публичный эндпоинт.
   * @summary Поиск классов МКТУ по словам
   * @param {SearchRequest} searchRequest Массив искомых слов
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MktuApiInterface
   */
  searchRaw(
    requestParameters: SearchOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Search200Response>>

  /**
   * Мультисловный поиск по классам МКТУ: для каждого переданного слова — найденные ключевые фразы классов; слова без соответствий собираются в data.undefined. Публичный эндпоинт.
   * Поиск классов МКТУ по словам
   */
  search(
    requestParameters: SearchOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Search200Response>
}

/**
 *
 */
export class MktuApi extends runtime.BaseAPI implements MktuApiInterface {
  /**
   * Экспорт выбранных классов МКТУ и их фраз в docx-файл (Word2007). Файл отдаётся как вложение (Content-Disposition: attachment), а не в конверте success_response. Публичный эндпоинт.
   * Экспорт классов МКТУ в docx
   */
  async _exportRaw(
    requestParameters: ExportOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['exportRequest'] == null) {
      throw new runtime.RequiredError(
        'exportRequest',
        'Required parameter "exportRequest" was null or undefined when calling _export().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/mktu/export`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ExportRequestToJSON(requestParameters['exportRequest']),
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Экспорт выбранных классов МКТУ и их фраз в docx-файл (Word2007). Файл отдаётся как вложение (Content-Disposition: attachment), а не в конверте success_response. Публичный эндпоинт.
   * Экспорт классов МКТУ в docx
   */
  async _export(
    requestParameters: ExportOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this._exportRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Конвертация docx-файла со списком фраз классов МКТУ в JSON: содержимое word/document.xml разбирается напрямую (разрывы строк внутри абзаца сохраняются как перевод строки). Публичный эндпоинт.
   * Импорт классов МКТУ из docx
   */
  async _importRaw(
    requestParameters: ImportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Import200Response>> {
    if (requestParameters['file'] == null) {
      throw new runtime.RequiredError(
        'file',
        'Required parameter "file" was null or undefined when calling _import().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any)
    }

    const response = await this.request(
      {
        path: `/api/v1/mktu/import`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Import200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Конвертация docx-файла со списком фраз классов МКТУ в JSON: содержимое word/document.xml разбирается напрямую (разрывы строк внутри абзаца сохраняются как перевод строки). Публичный эндпоинт.
   * Импорт классов МКТУ из docx
   */
  async _import(
    requestParameters: ImportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Import200Response> {
    const response = await this._importRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Список всех 45 классов МКТУ с описаниями, пояснениями и счётчиками фраз (отдаётся из кеша). Публичный эндпоинт.
   * Список классов МКТУ
   */
  async getClassesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetClasses200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/mktu/list`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetClasses200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список всех 45 классов МКТУ с описаниями, пояснениями и счётчиками фраз (отдаётся из кеша). Публичный эндпоинт.
   * Список классов МКТУ
   */
  async getClasses(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetClasses200Response> {
    const response = await this.getClassesRaw(initOverrides)
    return await response.value()
  }

  /**
   * По одному слову находит полные ключевые фразы классов МКТУ (подсказки при вводе). Запрос очищается от небезопасных символов, обрезается до 255 символов; поиск сохраняется в историю (для аутентифицированных — с привязкой к пользователю). Публичный эндпоинт.
   * Подсказки ключевых фраз МКТУ по слову
   */
  async getSuggestedWordRaw(
    requestParameters: GetSuggestedWordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetSuggestedWord200Response>> {
    if (requestParameters['word'] == null) {
      throw new runtime.RequiredError(
        'word',
        'Required parameter "word" was null or undefined when calling getSuggestedWord().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['word'] != null) {
      queryParameters['word'] = requestParameters['word']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/mktu/search/suggest`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetSuggestedWord200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * По одному слову находит полные ключевые фразы классов МКТУ (подсказки при вводе). Запрос очищается от небезопасных символов, обрезается до 255 символов; поиск сохраняется в историю (для аутентифицированных — с привязкой к пользователю). Публичный эндпоинт.
   * Подсказки ключевых фраз МКТУ по слову
   */
  async getSuggestedWord(
    requestParameters: GetSuggestedWordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetSuggestedWord200Response> {
    const response = await this.getSuggestedWordRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Все ключевые фразы указанного класса МКТУ, отсортированные по алфавиту и базовому номеру. Публичный эндпоинт.
   * Ключевые фразы класса МКТУ
   */
  async getWordsRaw(
    requestParameters: GetWordsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetWords200Response>> {
    if (requestParameters['classNumber'] == null) {
      throw new runtime.RequiredError(
        'classNumber',
        'Required parameter "classNumber" was null or undefined when calling getWords().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/mktu/list/{classNumber}`.replace(
          `{${'classNumber'}}`,
          encodeURIComponent(String(requestParameters['classNumber']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetWords200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Все ключевые фразы указанного класса МКТУ, отсортированные по алфавиту и базовому номеру. Публичный эндпоинт.
   * Ключевые фразы класса МКТУ
   */
  async getWords(
    requestParameters: GetWordsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetWords200Response> {
    const response = await this.getWordsRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Мультисловный поиск по классам МКТУ: для каждого переданного слова — найденные ключевые фразы классов; слова без соответствий собираются в data.undefined. Публичный эндпоинт.
   * Поиск классов МКТУ по словам
   */
  async searchRaw(
    requestParameters: SearchOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Search200Response>> {
    if (requestParameters['searchRequest'] == null) {
      throw new runtime.RequiredError(
        'searchRequest',
        'Required parameter "searchRequest" was null or undefined when calling search().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/mktu/search`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SearchRequestToJSON(requestParameters['searchRequest']),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Search200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Мультисловный поиск по классам МКТУ: для каждого переданного слова — найденные ключевые фразы классов; слова без соответствий собираются в data.undefined. Публичный эндпоинт.
   * Поиск классов МКТУ по словам
   */
  async search(
    requestParameters: SearchOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Search200Response> {
    const response = await this.searchRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
